import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class RegisterService {
    static registerCustomers(users, code) {

        const config = {
            params: {
                clientCode: code,
            }
        }

        return axios.post(`${API_BASE_URL}/foodz/api/v1/cadastro`, users, config)
    }

}

export default RegisterService;